<template>
  <div class="slot pfm-switch" @click="selectSlot" :class="{'selected': selected, 'disabled': !selectable}">

    <div class='header'>
    <div class="details radio-wrap" >
      <label class="times radio-label">
        {{data.from}} - {{data.to}}
      </label>
      <div class="price module-price">
        {{data.price|formatPrice}}
      </div>
    </div>
    </div>

  </div>
</template>

<script>
import Utils from '@/utils'

  export default {
    // name: 'delivery-planning-slot',
    props: ['data', 'order', 'methodCode', 'selectable'],
    data() {
      return {
        selected: this.data.selected
      }
    },
    created() {
      // console.log('SlotPanel.created', this.data, this.order, this.last)
    },
    // computed: {
    //   slotPrice() {
    //     return this.data.methodPrice[this.methodCode] ? this.data.methodPrice[this.methodCode] : '---'
    //   },
    // },
    watch: {
      data: {
        deep: true,
        handler() {
          // console.log('Changed', this.data.stopInFuture)
          this.selected = this.data.selected
        }
      }
    },
    methods: {
      selectSlot() {
        console.log(this.selectable, this.data, this.slotPrice, this.methodCode)
        if (this.selectable) {
          this.$emit('slot-selected', {
            id: this.data.id,
            mark: this.data.mark,
            price: this.data.methodPrice && this.data.methodPrice[this.methodCode] ? this.data.methodPrice[this.methodCode] : this.data.price,
            methodCode: this.methodCode,
            validUntil: this.data.validUntil
          })
          Utils.scrollTo({
            targetElementId: 'delivery-details'
          })
        }
      }
    }
  }
</script>

<style scoped>
</style>
